module.exports = __webpack_public_path__ + "img/DONT-LET.f58b33aa.jpg";